<script setup>
</script>

<template>
  <h1 class="ww-title">Dashboard</h1>
</template>
